import React, {Component} from 'react';
import Reveal from 'react-reveal';
import Player3 from "./Banner/videobtn3";

class AppGetstarted extends Component{
    state = {
        open: false
    };
    onOpenModal = () => {
        this.setState(prevState => ({
            open: !prevState.open
        }));
    };
    render() {
        return(
            <section className="get_started_area">
                <div className="shap one"/>
                <div className="shap two"/>
                <div className="shap one three"/>
                <div className="shap two four"/>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex align-items-center">
                            <Reveal bottom cascade>
                                <div className="get_content">
                                    <h3 className="f_400 f_p wow fadeInLeft" data-wow-delay="0.2s">GreenHubLK</h3>
                                    <h2 className="f_700 f_p f_size_40 l_height50 mb_20 wow fadeInLeft" data-wow-delay="0.3s">Download the app Now</h2>
                                    <p className="f_400 f_p mb_40 wow fadeInLeft" data-wow-delay="0.4s">Get yourself tucked in most astounding experience with the unique features of GreenHubLK. With all these features, GreenHub LK is just a click away from you.!</p>
                                    <a href="https://play.google.com/"  rel="noreferrer noopener" target="_blank" className="app_btn app_btn_one wow fadeInLeft" data-wow-delay="0.5s"><img src={require('../img/home7/google_icon.png')} alt=""/>Google Play</a>
                                    <button className="app_btn app_btn_two wow fadeInLeft" onClick={this.onOpenModal} data-wow-delay="0.6s"><i className="ti-control-play"/>Watch Demo</button>
                                    <Player3 open={this.state.open} toggleModal={this.onOpenModal} />
                                </div>
                            </Reveal>
                        </div>
                        <div className="col-lg-6 text-right">
                            <Reveal effect="fadeInRight" duration={2200}> <img src={require('../img/home7/iPhoneX2.png')} alt=""/></Reveal>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default AppGetstarted;
